export default "__VITE_ASSET__CuaDkMvB__"